import { lazy } from "react";

export const LazyReviewPage = lazy(async () => ({
    default: (await import("./ReviewPage")).ReviewPage
}));
